import { IApiResponse } from "@interfaces/generic/IApiResponse.ts"
import { IGetRestaurantAvailableCapacityResponseApi } from "@interfaces/IGetRestaurantAvailableCapacityResponseApi.ts"
import { IGetRestaurantAvailableCapacityResponseCli } from "@interfaces/IGetRestaurantAvailableCapacityResponseCli.ts"

export const GetRestaurantAvailableCapacityAdapter = (
	response: IApiResponse<IGetRestaurantAvailableCapacityResponseApi>
): IGetRestaurantAvailableCapacityResponseCli | null => {
	return response?.data
}
